"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeZonePicker = exports.DefaultTimeZone = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _underscore = _interopRequireDefault(require("underscore"));
var _reactstrap = require("reactstrap");
var DefaultTimeZone = exports.DefaultTimeZone = 'America/New_York';
_momentTimezone["default"].tz.setDefault(DefaultTimeZone);

/**
 * Time zone picker
 * @param {} param0
 */
var TimeZonePicker = exports.TimeZonePicker = function TimeZonePicker(props) {
  var value = props.value;
  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Input, (0, _extends2["default"])({}, props, {
    value: value || DefaultTimeZone,
    type: "select"
  }), getOptionNodes());
};
TimeZonePicker.propTypes = {
  value: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired
};
var getOptionNodes = function getOptionNodes() {
  var tzCache = {};
  var exclusionList = ['Pacific/', 'Atlantic/', 'US/Michigan', 'US/Pacific-New', 'US/Indiana-Starke', 'US/East-Indiana', 'America/Indiana/', 'America/Kentucky/', 'America/North_Dakota/', 'America/Atikokan', 'Antarctica/', 'Arctic/', 'W-SU', 'WET', 'Zulu', 'CST6CDT', 'PST8PDT'];
  var names = _momentTimezone["default"].tz.names();
  var nodes = names.sort(function (a, b) {
    //Sort anything starting with 'US' first
    var aIndex = a.indexOf('US');
    var bIndex = b.indexOf('US');
    if (aIndex === 0 && bIndex === 0) return 0;
    if (aIndex === 0) return -1;
    if (bIndex === 0) return 1;
    return 0;
  }).map(function (zone) {
    //Don't include things on the exclusion list
    if (_underscore["default"].any(exclusionList, function (exc) {
      return zone.indexOf(exc) === 0;
    })) return undefined;

    //Exclude all zones that begin with this prefix
    if (zone.indexOf('Etc/') >= 0) return undefined;

    //Group zones (eliminate ones with the same prefix and zone initials)
    var zoneParts = zone.split('/');
    zoneParts.pop();
    var cacheKey = "".concat(zoneParts.join('/'), "_").concat((0, _momentTimezone["default"])().tz(zone).format('Z_z'));
    if (tzCache[cacheKey] && zone !== DefaultTimeZone) return undefined;
    tzCache[cacheKey] = 1;
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: 'tz-opt-' + zone,
      value: zone
    }, zone, " ", (0, _momentTimezone["default"])().tz(zone).format('Z z'));
  }).filter(function (node) {
    return node;
  });
  return nodes;
};